import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import NativeVideo from '../../components/Video/NativeVideo/NativeVideo';
import YouTube from '../../components/Video/YouTube/YouTube';
import { buildVideoEvent } from '../../analytics/video';
import { getBrowserInfo } from '../../utils/get-browser-info';
import styles from '../../components/Video/Video.module.scss';
import { VIDEO_NAME } from '../../constants/analyticsNames';
import { VIDEO } from '../../constants/cmsResourceTypes';
import { useConfig } from '../../config/ContentComponentLibraryProvider';
const videoDefaultPropAnalytics = {};
const videoDefaultPropAnalyticsTags = {};
const videoDefaultPropBreakpointClasses = [];
const videoDefaultPropVideoPlayer = {};
const Video = ({ analytics = videoDefaultPropAnalytics, analyticsTags = videoDefaultPropAnalyticsTags, componentId = null, breakpointClasses = videoDefaultPropBreakpointClasses, externalUrl = '', videoPlayer = videoDefaultPropVideoPlayer, videoSource = '', position, }) => {
    const config = useConfig();
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        setMounted(true);
    }, []);
    const { isIos } = getBrowserInfo();
    return mounted ? (React.createElement("section", Object.assign({ className: classNames(styles.video, breakpointClasses) }, analyticsTags),
        videoSource === 'dam' && (React.createElement(NativeVideo, Object.assign({ analytics: Object.assign(Object.assign({}, analytics), { position }), componentId: componentId, isIos: isIos, videoLoaded: config.onAnalyticsEvent(buildVideoEvent), videoPlayed: config.onAnalyticsEvent(buildVideoEvent) }, videoPlayer))),
        videoSource === 'youtube' && React.createElement(YouTube, { externalUrl: externalUrl }))) : null;
};
Video.displayName = VIDEO_NAME;
Video.resourceType = VIDEO;
Video.propTypes = {
    componentId: PropTypes.string,
    locationName: PropTypes.string,
    analytics: PropTypes.shape({
        analyticsId: PropTypes.string,
    }),
    analyticsTags: PropTypes.shape({}),
    breakpointClasses: PropTypes.arrayOf(PropTypes.string),
    externalUrl: PropTypes.string,
    videoPlayer: PropTypes.shape({
        asset: PropTypes.string,
        componentId: PropTypes.string,
        posterimage: PropTypes.string,
        preload: PropTypes.string,
        serverurl: PropTypes.string,
        videoserverurl: PropTypes.string,
        viewer: PropTypes.string,
    }),
    videoSource: PropTypes.string,
    position: PropTypes.string.isRequired,
};
export default Video;
//# sourceMappingURL=index.js.map